import { defineComponent as _defineComponent } from 'vue'
import { AccountModal } from '@/lazy-load-components';
import BasicButton from '@/ui-components/BasicButton.vue';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginButton',
  props: {
    location: { default: '' }
  },
  setup(__props: any) {


const userStore = useUserStore();
const { setLoginProgress } = userStore;
const { isLoggedIn } = storeToRefs(userStore);

function openModal() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () =>
		setLoginProgress(false)
	);
}

return { __sfc: true,userStore, setLoginProgress, isLoggedIn, openModal, BasicButton }
}

})